import React from 'react'
import { IMaskInput } from 'react-imask'

export const maskCpf = {
    mask: [
        { mask: '000.000.000-00', maxLength: 11}
    ]
}
// { mask: '00.000.000/0000-00'}


const TextMask = React.forwardRef(function TextMask(props, ref) {

    const { onChange, ...other } = props

    return (
        <IMaskInput
            inputRef={ref}
            onAccept={(value) => {
                onChange({ target: { name: props.name, value } })
            }}
            onChange={() => {}}
            {...other}
        />
    )
})

export default TextMask